var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoLocationBus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 36,
  height: 44,
  viewBox: "0 0 36 44"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "suxokfqz5a",
  width: "146.4%",
  height: "136.1%",
  x: "-23.2%",
  y: "-15.3%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "82hwyvfmxb",
  d: "M18 39q14-13.701 14-21.635C32 9.431 25.732 3 18 3S4 9.431 4 17.365Q4 25.299 18 39"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#82hwyvfmxb",
  fill: "#000",
  filter: "url(#suxokfqz5a)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#82hwyvfmxb",
  fill: "#1A1A1A"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M11 21.25c0 .77.341 1.461.875 1.942v1.558c0 .481.394.875.875.875h.875a.88.88 0 0 0 .875-.875v-.875h7v.875c0 .481.394.875.875.875h.875a.88.88 0 0 0 .875-.875v-1.558c.534-.48.875-1.172.875-1.942V12.5C25 9.437 21.867 9 18 9s-7 .438-7 3.5zm3.063.875a1.31 1.31 0 0 1-1.313-1.313 1.31 1.31 0 0 1 1.313-1.312 1.31 1.31 0 0 1 1.312 1.313 1.31 1.31 0 0 1-1.313 1.312zm7.874 0a1.31 1.31 0 0 1-1.312-1.313 1.31 1.31 0 0 1 1.313-1.312 1.31 1.31 0 0 1 1.312 1.313 1.31 1.31 0 0 1-1.313 1.312m1.313-5.25h-10.5V12.5h10.5z"
}))));
export default SvgIcoLocationBus;